module.exports = __webpack_public_path__ + "img/Training_courses_img_7.7c3a7d24.jpg";